import { scroll_inst } from '../../utils';

function BackToTopButton() {
    const handleClick = () => {
        if (scroll_inst?.scroll) {
            scroll_inst.scroll(0, 900);
            return;
        }

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <button type="button" className="back-to-top" aria-label="Back to top" onClick={handleClick}>
            <span className="back-to-top-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none">
                    <path d="M12 19V5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6 11L12 5L18 11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </span>
        </button>
    );
}

export default BackToTopButton;
